<template>
  <v-container
    fluid
  >
    <v-row dense no-gutters v-if="$store.state.brand != 'cldy'">
      <v-app-bar
        app
        dense
      >
        <a v-if="$store.state.brand === 'qoxy'" href="https://manage.qoxy.com">
          <img src="/qoxylogo.png">
        </a>
        <v-spacer></v-spacer>
        <a class="header-btn" @click="gotoLogin()">LOGIN</a>
        <span>|</span>
        <a class="header-btn" @click="gotoLogin()">REGISTER</a>
        <v-badge
          color="green"
          :content="$store.state.shoppingCart.total_count + ''"
          overlap
          offset-x="20"
          offset-y="20"
        >
          <v-btn
            icon
            large
            @click="goToCart()"
          >
            <v-avatar
              size="32px"
              item
            >
              <v-icon>mdi-cart-outline</v-icon>
            </v-avatar>
          </v-btn>
        </v-badge>
      </v-app-bar>
    </v-row>
    <CldyHeader v-if="$store.state.brand == 'cldy'"></CldyHeader>
    <v-row
      v-if="paynowPaymentRecovery
        || airwallexInvoiceRecovery
        || airwallexInvoiceRecoveryUnavailable"
    >
      <v-col cols="12" md="10" offset-md="1">
        <v-alert
          :type="paynowPaymentRecovery
            ? (paynowInvoiceCanRequestPaymentMethodSwitch ? 'info' : 'warning')
            : airwallexInvoiceRecoveryUnavailable
            || (airwallexInvoiceRecovery
              && airwallexInvoiceRecovery.recoverable === false)
            ? 'error' : 'info'"
          dense
          outlined
        >
          <div>{{ paynowPaymentRecovery
            ? paynowInvoiceRecoveryMessage
            : airwallexInvoiceRecoveryMessage }}</div>
          <v-btn
            v-if="paynowInvoiceRecoveryRefreshRecommended
              || airwallexInvoiceRecoveryRefreshRecommended"
            class="mt-2"
            color="primary"
            small
            :loading="airwallexInvoiceRecoveryLoading"
            :disabled="loading || airwallexInvoiceCancellationInProgress"
            @click="refreshAirwallexInvoiceStatus()"
          >
            Refresh payment status
          </v-btn>
          <v-btn
            v-if="airwallexInvoiceRecoveryRequiresAuthentication"
            class="mt-2"
            color="primary"
            small
            :disabled="loading || airwallexInvoiceRecoveryLoading
              || airwallexInvoiceCancellationInProgress"
            @click="gotoLogin()"
          >
            Sign in to continue
          </v-btn>
        </v-alert>
      </v-col>
    </v-row>
    <v-row v-if="invoice && invoice.invoiceStatusId == 4">
      <v-col cols="12" md="10" offset-md="1">
      <v-card
        outlined
      >
        <v-card-text>
          <v-row no-gutters dense>
            <v-col cols="12">
              <div class="subtitle-2 mb-1">Payment Method</div>
              <v-radio-group
                :value="paymentMethod"
                :disabled="loading || airwallexInvoiceRecoveryLockRequired"
                @change="selectAirwallexInvoicePaymentMethod"
                row
                class="mt-0"
              >
                <v-radio
                  v-for="method in paymentMethods"
                  :key="method.value"
                  :label="method.text"
                  :value="method.value"
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-form
            ref="form"
            v-if="!airwallexInvoiceRecoveryUnavailable"
          >
            <v-row no-gutters dense>
              <v-col cols="12" md="2">
                <h1>Total: {{ amount }}</h1>
              </v-col>
            </v-row>
            <v-row no-gutters dense v-if="paymentMethod == 1">
              <v-col cols="12">
                <br>
                <v-divider></v-divider>
                <br>
              </v-col>
              <v-col cols="12" md="4" v-if="$store.state.brand == 'cldy'">
                <h2>Bank Transfer</h2>
                <p>Payee: CLDY.com Pte Ltd<br>
                Name of Bank: DBS BANK<br>
                Account No.: 0720348400<br>
                Bank Code: 7171<br>
                Branch Code: 072</p>
              </v-col>
              <v-col cols="12" md="4" v-else>
                <h2>Bank Transfer</h2>
                <p>Payee: GoCloudEasy Pte Ltd<br>
                  Name of Bank: DBS BANK<br>
                  Account No.: 0109065458<br>
                  Bank Code: 7171<br>
                  Branch Code: 001</p>
              </v-col>
              <v-col cols="12" md="4" v-if="$store.state.brand == 'cldy'">
                  <h2>Cheque Payment</h2>
                  <p>Payable to: CLDY.com Pte Ltd<br>
                    Notes:<br>
                    Write invoice number at the back of the cheque<br>
                    Drop into DBS Quick Cheque Deposit box</p>
              </v-col>
              <v-col cols="12" md="4" v-else>
                <h2>Cheque Payment</h2>
                <p>Payable to: Gocloudeasy Pte Ltd<br>
                  Notes:<br>
                  Write invoice number at the back of the cheque<br>
                  Drop into DBS Quick Cheque Deposit box</p>
              </v-col>
              <v-col cols="12" md="4" v-if="$store.state.brand == 'cldy'">
                <h2>PayNow</h2>
                <p>UEN No.: 202107287N<br>
                  Company Name: CLDY.com Pte Ltd</p>
                <div>
                  <img alt="paynow image" :src="paynowImage">
                </div>
              </v-col>
              <v-col cols="12" md="4" v-else>
                <h2>PayNow</h2>
                <p>UEN No.: 202022399N<br>
                  Company Name: GoCloudEasy Pte Ltd</p>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field label="Bank"
                              :rules="[rules.required]"
                              v-model="bank"></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field label="Reference No"
                              :rules="[rules.required]"
                              v-model="referenceNo"></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field label="Transfer Datetime"
                              :rules="[rules.required]"
                              v-model="transferDatetime"
                              @click.prevent="openDatetimePicker($event)"
                              :readonly="true"
                ></v-text-field>
                <datetime
                  class="datetime-picker"
                  ref="datetimePicker"
                  type="datetime"
                  v-model="pickerTransferDatetime"
                  :hour-step="1"
                  :minute-step="5"
                  format="yyyy-MM-dd HH:mm:ss"
                  auto
                ></datetime>
              </v-col>
            </v-row>
            <div v-if="paymentMethod == 3">
              <v-row no-gutters dense>
                <v-col cols="12" md="6">
                  <stripe-payment
                    :amount="amount"
                    :card.sync="creditCard"
                    :invalid.sync="creditCardInvalid"
                  ></stripe-payment>
                </v-col>
              </v-row>
            </div>
            <div v-if="paymentMethod == 4">
              <v-row no-gutters dense>
                <v-col cols="12" md="6">
                  <paypal-payment
                    :amount="amount"
                    :orderid="paypalOrderId"
                    @interface="getChildInterface"
                    :saveasdefaultcard="false"
                    :card.sync="creditCard"
                    :invalid.sync="creditCardInvalid"
                  ></paypal-payment>
                </v-col>
              </v-row>
            </div>
            <div v-if="paymentMethod == 6">
              <p v-if="!paynowPaymentRecovery || paynowInvoiceCanRetry || paynowReady">
                Note: Please open up your banking app and prepare to Scan and Pay.
                This QR code is dynamically generated and payment has to be completed
                within 1 hour after the QR code is generated.
              </p>
              <div v-if="paynowReady">
                <img :src="paynowImage2" width="160">
              </div>
            </div>
            <div v-if="[7, 8].includes(paymentMethod)">
              <v-row no-gutters dense>
                <v-col cols="12" md="6">
                  <airwallex-payment
                    :allow-apple-pay="applePayEnabled"
                      :apple-pay="airwallexWalletSelected"
                      :key="paymentMethod"
                    @apple-pay-selected="selectAirwallexApplePay"
                    :amount="amount"
                    :invalid.sync="creditCardInvalid"
                    :disabled="loading || airwallexInvoiceRecoveryLoading
                      || airwallexInvoiceCancellationInProgress
                      || airwallexInvoiceRecoveryUnavailable
                      || (airwallexInvoiceRecovery
                      && (airwallexInvoiceRecovery.action !== 'authorize'
                        || airwallexInvoiceRecovery.mode !== 'new'))"
                    @interface="getAirwallexInterface"
                  ></airwallex-payment>
                </v-col>
              </v-row>
            </div>
          </v-form>
          <v-row no-gutters dense v-if="$store.state.brand === 'cldy'">
            <v-col cols="12">
              <div class="d-flex justify-end">
                <v-checkbox
                  v-model="tosAccepted"
                  hide-details
                  class="mb-2"
                  :disabled="loading || !!tosAuditPromise
                    || airwallexInvoiceRecoveryLoading
                    || airwallexInvoiceCancellationInProgress
                    || airwallexInvoiceRecoveryUnavailable"
                  @change="recordTosDecision"
                >
                  <template v-slot:label>
                    <div>
                      I have read, understood, and accept the
                      <a
                        href="https://www.cldy.com/sg/terms-of-service/"
                        target="_blank"
                        rel="noopener"
                        @click.stop
                      >Terms of Service</a>.
                    </div>
                  </template>
                </v-checkbox>
              </div>
            </v-col>
          </v-row>
          <v-row no-gutters dense>
            <v-col cols="12" class="text-right">
              <v-btn
                v-if="paymentMethod == 4"
                color="primary"
                :loading="loading"
                :disabled="airwallexInvoiceRecoveryLoading
                  || airwallexInvoiceCancellationInProgress
                  || airwallexInvoiceRecoveryUnavailable
                  || ($store.state.brand === 'cldy'
                    && (!tosAccepted || !tosAuditSucceeded || !!tosAuditPromise))"
                @click="submit">
                  {{ airwallexWalletSelected
                    ? 'Continue with Apple Pay' : 'Make Payment (Visa/Master)' }}
                </v-btn>
              <v-btn
                v-else-if="paymentMethod == 6"
                color="primary"
                :loading="loading"
                :disabled="airwallexInvoiceRecoveryLoading
                  || airwallexInvoiceCancellationInProgress
                  || airwallexInvoiceRecoveryUnavailable
                  || (!!paynowPaymentRecovery && !paynowInvoiceCanRetry)
                  || ($store.state.brand === 'cldy'
                    && (!tosAccepted || !tosAuditSucceeded || !!tosAuditPromise))"
                @click="submit">{{ paynowInvoiceButtonLabel }}</v-btn>
              <v-btn
                v-else-if="[7, 8].includes(paymentMethod)"
                color="primary"
                :loading="loading"
                :disabled="airwallexInvoiceRecoveryLoading
                  || airwallexInvoiceCancellationInProgress
                  || airwallexInvoiceRecoveryUnavailable
                  || (airwallexInvoiceRecovery
                  && airwallexInvoiceRecovery.recoverable === false)
                  || ($store.state.brand === 'cldy'
                    && (!tosAccepted || !tosAuditSucceeded || !!tosAuditPromise))"
                @click="submit">{{ airwallexInvoiceButtonLabel }}</v-btn>
              <v-btn
                v-else
                color="primary"
                :loading="loading"
                :disabled="airwallexInvoiceRecoveryLoading
                  || airwallexInvoiceCancellationInProgress
                  || airwallexInvoiceRecoveryUnavailable
                  || ($store.state.brand === 'cldy'
                    && (!tosAccepted || !tosAuditSucceeded || !!tosAuditPromise))"
                @click="submit">
                <span v-if="$store.state.brand == 'cldy'">Notify CLDY on Payment</span>
                <span v-else>Notify on Payment</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    </v-row>
    <v-row v-if="invoice && invoice.invoiceStatusId != 4">
      <v-col cols="12" md="10" offset-md="1">
      <v-card
        outlined
      >
        <v-card-text>
          <v-row no-gutters dense v-if="invoice.invoiceStatusId == 2">
            <h2 class="orange--text">Pending Approval</h2>
          </v-row>
          <v-row no-gutters dense  v-if="invoice.invoiceStatusId == 1">
            <h2 class="green--text">Paid</h2>
          </v-row>
          <v-row no-gutters dense  v-if="invoice.invoiceStatusId == 5">
            <h2 class="red--text">Cancelled</h2>
          </v-row>
          <br>
          <v-row no-gutters dense>
            <v-col cols="12" class="text-left">
              <v-btn color="success"
                     @click="downloadPdf">Download PDF</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="10" offset-md="1">
      <v-row v-if="invoice">
        <v-col cols="12" md="6">
          <p><b>Invoice Date</b>: {{ invoice.invoiceDatetime }}</p>
          <p><b>Invoice NO</b>: {{ invoice.invoiceNo }}</p>
          <p><b>Name</b>: {{ invoice.customerFirstName }} {{ invoice.customerLastName }}</p>
          <p><b>Company</b>: {{ invoice.customerCompanyName }}</p>
          <p v-if="invoice.customerAddress1 != ''">
            <b>Address1</b>: {{ invoice.customerAddress1 }}</p>
          <p v-if="invoice.customerAddress2 != ''">
            <b>Address2</b>: {{ invoice.customerAddress2 }}</p>
          <p><b>City</b>: {{ invoice.customerCity }}</p>
          <p><b>Country</b>: {{ invoice.customerCountry }}</p>
          <p><b>Postcode</b>: {{ invoice.customerPostalCode }}</p>
        </v-col>
      </v-row>
      <v-simple-table>
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-left">
              Description
            </th>
            <th class="text-right">
              Discount
            </th>
            <th class="text-right">
              Amount
            </th>
          </tr>
          </thead>
          <tbody>
          <tr
            v-for="item in items"
            :key="item.id"
          >
            <td><pre>{{ item.invoiceLineDescription }}</pre></td>
            <td class="text-right">${{ item.discount }}</td>
            <td class="text-right">${{ item.subtotal }}</td>
          </tr>
          <tr v-if="invoice && invoice.discount > 0">
            <td colspan="3" class="text-right">Discount: ${{ invoice.discount }}</td>
          </tr>
          <tr v-if="invoice && invoice.tax > 0">
            <td colspan="3" class="text-right">Add GST @9%: ${{ invoice.tax }}</td>
          </tr>
          <tr v-if="invoice && invoice.total >= 0">
            <td colspan="3" class="text-right">Total: ${{ invoice.total }}</td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-col>
    </v-row>
    <v-row v-if="invoice && invoice.invoiceStatusId == 4">
      <v-col cols="12" md="10" offset-md="1">
      <v-card
        outlined
      >
        <v-card-text>
          <v-row no-gutters dense>
            <v-col cols="6" class="text-left">
              <v-btn color="success"
                     @click="downloadPdf">Download PDF</v-btn>
            </v-col>
            <v-col cols="6" class="text-right">
              <v-btn color="error"
                     :loading="loading"
                     :disabled="airwallexInvoiceRecoveryLoading
                       || airwallexInvoiceCancellationInProgress
                       || airwallexInvoiceRecoveryUnavailable
                       || !!airwallexInvoiceRecovery
                       || !!paynowPaymentRecovery"
                     style="margin-right: 10px;"
                     @click="cancel">Cancel</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    </v-row>
    <v-footer
      v-if="$store.state.brand != 'cldy'"
      dark
      padless
      :app="true"
      :fixed="true"
    >
      <v-card
        flat
        tile
        class="indigo lighten-1 white--text text-center"
        width="100%"
      >
        <v-card-text class="white--text">
          {{ new Date().getFullYear() }} — <strong>Powered By GoCloudEasy Pte Ltd</strong>
        </v-card-text>
      </v-card>
    </v-footer>
    <CldyFooter v-if="$store.state.brand == 'cldy'"></CldyFooter>
  </v-container>
</template>

<script>
import { DateTime } from 'luxon';
import { mapState } from 'vuex';
import airwallexWallet from '../../mixins/airwallex-wallet';
import { StripePayment, PaypalPayment, AirwallexPayment } from '../components/payment_modules';
import {
  creditCardPaymentMethodLabel,
  isAirwallexPaymentPending,
} from '../../plugins/airwallex-payment';
import { recordTosDecision as auditTosDecision } from '../../plugins/tos-audit';
import airwallexInvoiceRecovery from '../../mixins/airwallex-invoice-recovery';
import CldyHeader from './CldyHeader.vue';
import CldyFooter from './CldyFooter.vue';

export default {
  name: 'ShoppingCart',
  mixins: [airwallexWallet, airwallexInvoiceRecovery],
  components: {
    StripePayment,
    PaypalPayment,
    AirwallexPayment,
    CldyHeader,
    CldyFooter,
  },
  data() {
    return {
      bank: '',
      referenceNo: '',
      transferDatetime: null,
      pickerTransferDatetime: null,
      paymentMethod: '',
      paymentMethods: [],
      amount: '',
      paypalOrderId: '',
      loading: false,
      creditCardInvalid: null,
      creditCard: null,
      rules: {
        required: (value) => !!value || 'This field is required.',
      },
      items: [],
      invoice: null,
      firstInvoice: false,
      gtagObj: {},
      paynowImage: null,
      paynowReady: 0,
      paynowImage2: '#',
      paymentId: null,
      tosAccepted: false,
      tosAuditPromise: null,
      tosAuditSucceeded: true,
    };
  },
  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    localComputed() {
    },
    // mix this into the outer object with the object spread operator
    ...mapState({
      shoppingCart: 'shoppingCart',
    }),
  },
  created() {
    this.$api.get(`partner/payment-methods?token=${this.$route.query.token}`).then((response) => {
      const paymentMethods = this.filterWalletPaymentMethods(response.data).map((method) => ({
        ...method,
        text: creditCardPaymentMethodLabel(method),
      }));

      this.$set(this, 'paymentMethods', paymentMethods);
      if (this.airwallexInvoiceRecovery) {
        this.$set(this, 'paymentMethod', Number((this.airwallexInvoiceRecovery || {}).payment_type_id) || 7);
        return;
      }

      // The methods request can finish after a guarded cancellation and a
      // deliberate customer selection. Initialization must not undo it.
      if (this.paymentMethod !== '' && this.paymentMethod !== null) {
        return;
      }

      if (this.$route.query.payment) {
        this.$set(this, 'paymentMethod', parseInt(this.$route.query.payment, 10));
      } else {
        this.$api.get(`partner/default-payment-method?token=${this.$route.query.token}`).then((subresponse) => {
          if (this.paymentMethod !== '' && this.paymentMethod !== null) {
            return;
          }

          this.$set(
            this,
            'paymentMethod',
            this.airwallexInvoiceRecovery ? 7 : subresponse.data,
          );
        });
      }
    });

    this.$api.get(`has-no-invoice?invoice_id=${this.$route.params.id}&express_token=${this.$route.query.token}`)
      .then((response) => {
        this.$set(this, 'firstInvoice', response.data.has_no_invoice);
      });

    this.refreshAirwallexInvoiceStatus();
    this.transferDatetime = DateTime.local().toFormat('yyyy-MM-dd HH:mm:ss');
    this.pickerTransferDatetime = DateTime.local().toISO();
  },
  methods: {
    airwallexInvoiceDetailEndpoint() {
      return `tax-invoice/${this.$route.params.id}/detail?express_token=${this.$route.query.token}`;
    },
    airwallexInvoiceCancellationEndpoint() {
      return 'payment/invoice-recovery/cancel';
    },
    airwallexInvoiceCancellationPayload(recovery) {
      if (Number(recovery.payment_type_id) === 6) {
        return {
          invoice_id: this.$route.params.id,
          token: this.$route.query.token,
          payment_id: recovery.payment_id,
        };
      }

      return {
        invoice_id: this.$route.params.id,
        token: this.$route.query.token,
        payment_intent_id: recovery.payment_intent_id,
      };
    },
    paynowInvoiceStatusEndpoint(paymentId) {
      return `payment/${paymentId}/check-paynow-status`;
    },
    paynowInvoiceStatusPayload() {
      return {
        invoice_id: this.$route.params.id,
        token: this.$route.query.token,
      };
    },
    onPaynowInvoicePaymentSucceeded() {
      this.$store.dispatch('addAlert', {
        id: Date.now(),
        type: 'success',
        message: 'Your payment is submitted successfully.',
      });
      this.reset();
    },
    airwallexInvoiceRecoveryModes() {
      return ['new', 'status_only'];
    },
    onAirwallexInvoiceDetailSynced(detail) {
      this.syncAirwallexInvoicePresentation(detail);
    },
    getChildInterface(childInterface) {
      this.$options.childInterface = childInterface;
    },
    getAirwallexInterface(childInterface) {
      this.$options.airwallexInterface = childInterface;
    },
    gotoLogin() {
      const { brand } = this.$store.state;
      this.$router.push({ name: 'Retail.Login', params: { brand } })
        .catch(() => {
        });
    },
    goToCart() {
      const { brand } = this.$store.state;
      if (this.$store.state.user.role) {
        this.$router.push({
          name: 'Retail.ShoppingCart',
          params: { brand },
        })
          .catch(() => {
          });
      } else {
        this.$router.push({
          name: 'Retail.GuestShoppingCart',
          params: { brand },
        })
          .catch(() => {
          });
      }
    },
    gotoHome() {
      const { brand } = this.$store.state;
      this.$router.push({ name: 'Retail.Guest', params: { brand } })
        .catch(() => {
        });
    },
    openDatetimePicker(event) {
      this.$refs.datetimePicker.open(event);
    },
    reset() {
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    },
    recordTosDecision(checked) {
      this.tosAuditSucceeded = false;
      const auditRequest = auditTosDecision({
        api: this.$api,
        store: this.$store,
        checked,
        context: 'express_invoice_payment',
        invoiceId: this.$route.params.id,
        token: this.$route.query.token,
      }).then(() => {
        if (this.tosAuditPromise === auditRequest) {
          this.tosAuditSucceeded = true;
        }
        return true;
      }).catch(() => false).finally(() => {
        if (this.tosAuditPromise === auditRequest) {
          this.tosAuditPromise = null;
        }
      });
      this.tosAuditPromise = auditRequest;
    },
    async submit() {
      if (this.loading
        || this.airwallexInvoiceRecoveryLoading
        || this.airwallexInvoiceCancellationInProgress
        || this.airwallexInvoiceRecoveryUnavailable
      ) {
        return;
      }
      if (this.$store.state.brand === 'cldy' && !this.tosAccepted) {
        return;
      }
      this.loading = true;

      let pendingTosAudit = this.tosAuditPromise;
      while (pendingTosAudit) {
        // eslint-disable-next-line no-await-in-loop
        await pendingTosAudit;
        pendingTosAudit = this.tosAuditPromise;
      }
      if (!this.tosAuditSucceeded
        || (this.$store.state.brand === 'cldy' && !this.tosAccepted)
      ) {
        this.loading = false;
        return;
      }

      if (!this.$refs.form.validate()) {
        this.loading = false;
        return;
      }

      if ((this.paymentMethod === 3 || [7, 8].includes(this.paymentMethod))
        && this.creditCardInvalid
        && !([7, 8].includes(this.paymentMethod)
          && this.airwallexInvoiceRecovery
          && this.airwallexInvoiceRecovery.payment_intent_id)
      ) {
        this.loading = false;
        return;
      }

      if (this.paymentMethod === 1) {
        this.$api.post('payment', {
          payment_type_id: this.paymentMethod,
          bank: this.bank,
          reference_no: this.referenceNo,
          transfer_datetime: this.transferDatetime,
          amount: this.amount,
          invoice_id: this.$route.params.id,
          token: this.$route.query.token,
        })
          .then(() => {
            if (this.firstInvoice && this.$store.state.brand === 'cldy') {
              window.gtag('event', 'purchase', this.gtagObj);
            }
            const successMessage = 'Your payment is submitted successfully. Admin will review and confirm the payment.';
            this.$store.dispatch('addAlert', {
              id: Date.now(),
              type: 'success',
              message: successMessage,
            });
            this.reset();
          })
          .finally(() => {
            this.loading = false;
          });
      }

      if (this.paymentMethod === 3) {
        this.$api.post('payment', {
          payment_type_id: this.paymentMethod,
          amount: this.amount,
          invoice_id: this.$route.params.id,
          token: this.$route.query.token,
          save_as_default_card: false,
        })
          .then((response) => {
            const stripePaymentObj = {
              payment_method: {
                card: this.creditCard,
              },
            };

            return window.stripeClient.confirmCardPayment(
              response.data.client_secret,
              stripePaymentObj,
            )
              .then(async (result) => {
                if (result.error) {
                  await this.$store.dispatch('addAlert', {
                    id: Date.now(),
                    type: 'error',
                    message: result.error,
                  });
                } else if (result.paymentIntent.status === 'requires_capture') {
                  await this.$api.post('payment', {
                    invoice_id: this.$route.params.id,
                    token: this.$route.query.token,
                    payment_type_id: this.paymentMethod,
                    capture: 1,
                    id: result.paymentIntent.id,
                  })
                    .then(() => {
                      if (this.firstInvoice && this.$store.state.brand === 'cldy') {
                        window.gtag('event', 'purchase', this.gtagObj);
                      }

                      const successMessage = 'Your payment is submitted successfully.';
                      this.$store.dispatch('addAlert', {
                        id: Date.now(),
                        type: 'success',
                        message: successMessage,
                      });
                      this.reset();
                    });
                }
              });
          })
          .finally(() => {
            this.loading = false;
          });
      }

      if (this.paymentMethod === 4) {
        this.$api.post('payment', {
          payment_type_id: this.paymentMethod,
          amount: this.amount,
          invoice_id: this.$route.params.id,
          token: this.$route.query.token,
          save_as_default_card: false,
        })
          .then((response) => {
            this.$set(this, 'paypalOrderId', response.data.order_id);
            return this.$nextTick()
              .then(() => this.$options.childInterface.checkout())
              .then((payload) => {
                if (payload.liabilityShift !== 'NO'
                  && payload.authenticationStatus
                  && payload.authenticationStatus !== 'YES') {
                  this.$store.dispatch('addAlert', {
                    id: Date.now(),
                    type: 'error',
                    message: '3D Secure Authentication fails. Please retry again.',
                  });
                  this.loading = false;
                  return null;
                }

                if (payload.liabilityShift === 'NO'
                  && payload.liabilityShifted === false
                  && payload.authenticationStatus
                  && payload.authenticationStatus === 'NO') {
                  this.$store.dispatch('addAlert', {
                    id: Date.now(),
                    type: 'error',
                    message: 'You have exited 3D Secure Authentication. Please retry again.',
                  });
                  this.loading = false;
                  return null;
                }

                return this.$api.post('payment', {
                  payment_type_id: this.paymentMethod,
                  confirm: 1,
                  capture: 1,
                  id: payload.orderId,
                  amount: this.amount,
                  invoice_id: this.$route.params.id,
                  token: this.$route.query.token,
                  save_as_default_card: false,
                })
                  .then(() => {
                    if (this.firstInvoice && this.$store.state.brand === 'cldy') {
                      window.gtag('event', 'purchase', this.gtagObj);
                    }

                    this.$store.dispatch('addAlert', {
                      id: Date.now(),
                      type: 'success',
                      message: 'Your payment is submitted successfully.',
                    });
                    this.reset();
                  });
              })
              .catch((error) => {
                if (error.message.indexOf('semantically incorrect') > 0
                  || error.message.indexOf('not well-formed') > 0) {
                  this.$store.dispatch('addAlert', {
                    id: Date.now(),
                    type: 'error',
                    message: 'We are sorry, the transaction failed. Please check the card information or try with another card.',
                  });
                } else {
                  this.$store.dispatch('addAlert', {
                    id: Date.now(),
                    type: 'error',
                    message: `An error occurred ${error.message}. Please retry again.`,
                  });
                }
                this.loading = false;
              });
          })
          .finally(() => {
            this.loading = false;
          });
      }

      if (this.paymentMethod === 6) {
        this.$api.post('payment', {
          payment_type_id: this.paymentMethod,
          amount: this.amount,
          invoice_id: this.$route.params.id,
          token: this.$route.query.token,
        })
          .then((response) => {
            this.rememberPaynowInvoicePaymentResponse(response.data);
          })
          .finally(() => {
            this.loading = false;
          });
      }

      if ([7, 8].includes(this.paymentMethod)) {
        const recoveryPayment = this.airwallexInvoiceRecovery;

        if (recoveryPayment && recoveryPayment.recoverable === false) {
          this.$store.dispatch('addAlert', {
            id: Date.now(),
            type: 'error',
            message: this.airwallexInvoiceRecoveryRequiresAuthentication
              ? 'Sign in as the invoice owner to continue the saved-card payment.'
              : 'The active credit card payment requires reconciliation. Please contact support.',
          });
          this.loading = false;
          return;
        }

        const statusOnlyRecovery = recoveryPayment
          && recoveryPayment.mode !== 'new';

        if (statusOnlyRecovery) {
          if (!recoveryPayment.payment_intent_id) {
            this.$store.dispatch('addAlert', {
              id: Date.now(),
              type: 'error',
              message: 'Sign in to continue the active credit card payment, or contact support.',
            });
            this.loading = false;
            return;
          }

          const capturePayment = () => this.$api.post('payment', {
            invoice_id: this.$route.params.id,
            token: this.$route.query.token,
            payment_type_id: Number(this.paymentMethod),
            capture: 1,
            id: recoveryPayment.payment_intent_id,
          });

          this.pollAirwallexInvoicePayment(capturePayment)
            .then((response) => {
              if (!response) {
                return;
              }

              if (isAirwallexPaymentPending(response)) {
                this.resetAirwallexRetryConsent();
                this.$store.dispatch('addAlert', {
                  id: Date.now(),
                  type: 'info',
                  message: 'Your card payment is still processing. This invoice has not been marked as paid yet.',
                });
                return;
              }

              this.airwallexInvoiceRecovery = null;
              this.$store.dispatch('addAlert', {
                id: Date.now(),
                type: 'success',
                message: 'Your payment is submitted successfully.',
              });
              this.reset();
            })
            .catch((error) => this.handleAirwallexInvoiceError(error))
            .finally(() => {
              this.loading = false;
            });
          return;
        }

        this.rememberAirwallexInvoiceRecovery({
          paymentIntentId: recoveryPayment && recoveryPayment.payment_intent_id,
        });

        this.$api.post('payment', {
          payment_type_id: Number(this.paymentMethod),
          amount: this.amount,
          invoice_id: this.$route.params.id,
          token: this.$route.query.token,
        })
          .then((response) => {
            const paymentIntentId = this
              .resolveAirwallexInvoicePaymentIntentId(response);

            if (!paymentIntentId) {
              throw new Error('The credit card processor did not return active payment details.');
            }

            this.rememberAirwallexInvoiceRecovery({
              paymentIntentId,
            });

            const capturePayment = () => this.$api.post('payment', {
              invoice_id: this.$route.params.id,
              token: this.$route.query.token,
              payment_type_id: Number(this.paymentMethod),
              capture: 1,
              id: paymentIntentId,
            });
            const waitForCapture = () => this.pollAirwallexInvoicePayment(
              capturePayment,
              isAirwallexPaymentPending(response) ? response : null,
            );

            if (isAirwallexPaymentPending(response)) {
              return waitForCapture();
            }

            if (this.creditCardInvalid) {
              this.$store.dispatch('addAlert', {
                id: Date.now(),
                type: 'info',
                message: 'Re-enter the card details, then select Resume credit card payment.',
              });
              return null;
            }

            if (!response.data.client_secret || !this.$options.airwallexInterface) {
              throw new Error('The credit card payment form is not ready.');
            }

            return this.$options.airwallexInterface.confirmIntent(
              paymentIntentId,
              response.data.client_secret,
            ).then(waitForCapture);
          })
          .then((response) => {
            if (!response) {
              return;
            }

            if (isAirwallexPaymentPending(response)) {
              this.resetAirwallexRetryConsent();
              this.$store.dispatch('addAlert', {
                id: Date.now(),
                type: 'info',
                message: 'Your card payment is still processing. This invoice has not been marked as paid yet.',
              });
              return;
            }

            if (this.firstInvoice && this.$store.state.brand === 'cldy') {
              window.gtag('event', 'purchase', this.gtagObj);
            }

            this.airwallexInvoiceRecovery = null;
            const successMessage = 'Your payment is submitted successfully.';
            this.$store.dispatch('addAlert', {
              id: Date.now(),
              type: 'success',
              message: successMessage,
            });
            this.reset();
          })
          .catch((error) => this.handleAirwallexInvoiceError(error))
          .finally(() => {
            this.loading = false;
          });
      }
    },
    cancel() {
      if (this.loading
        || this.airwallexInvoiceRecoveryLoading
        || this.airwallexInvoiceCancellationInProgress
        || this.airwallexInvoiceRecoveryUnavailable
        || this.airwallexInvoiceRecovery
        || this.paynowPaymentRecovery
      ) {
        return;
      }

      /* eslint-disable no-alert */
      const r = window.confirm('Are you sure to cancel this invoice?');
      if (r === true) {
        this.loading = true;

        this.$api.post('express-cancel', {
          invoice_id: this.$route.params.id,
          token: this.$route.query.token,
        })
          .then(() => {
            this.$store.dispatch('addAlert', {
              id: Date.now(),
              type: 'success',
              message: 'Invoice is cancelled successfully.',
            });

            this.reset();
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    downloadPdf() {
      window.open(`/invoice.php?invoice_no=${this.invoice.invoiceNo}&view_token=${this.$route.query.token}`);
    },
  },
  watch: {
    pickerTransferDatetime: {
      handler(newPickerTransferDatetime) {
        if (newPickerTransferDatetime !== null) {
          this.transferDatetime = DateTime.fromISO(newPickerTransferDatetime)
            .toFormat('yyyy-MM-dd HH:mm:ss');
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.cart {
  max-height: 640px;
  overflow-y: scroll;
}

.pay-btn {
  margin-left: 10px;
}
</style>
